import { render } from "./ListeBescPage.vue?vue&type=template&id=5b5501f1&ts=true"
import script from "./ListeBescPage.vue?vue&type=script&lang=ts"
export * from "./ListeBescPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__